// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.external_test_partner_status_enum */
var ExternalTestPartnerStatusEnum;
(function (ExternalTestPartnerStatusEnum) {
    ExternalTestPartnerStatusEnum["ACTIVE"] = "ACTIVE";
    ExternalTestPartnerStatusEnum["NEEDS_REVIEW"] = "NEEDS_REVIEW";
    ExternalTestPartnerStatusEnum["INACTIVE"] = "INACTIVE";
})(ExternalTestPartnerStatusEnum || (ExternalTestPartnerStatusEnum = {}));
;
export default ExternalTestPartnerStatusEnum;
/** Zod schema for external_test_partner_status_enum */
export const externalTestPartnerStatusEnum = z.nativeEnum(ExternalTestPartnerStatusEnum);
//# sourceMappingURL=ExternalTestPartnerStatusEnum.js.map